export default {
  black: '#000',
  danger: '#FF669D',
  dark: '#444',
  darkGrey: '#999',
  gray: '#EBF2F5',
  info: '#4d85ee',
  lightGrey: '#eee',
  primary: '#ee4d64',
  secondary: '#312e38',
  success: '#31DB7D',
  white: '#fff',
  brand: '#1a90e8',
  yellow: '#FFD666',

  blueSky: '#96FEFF',
  blueSkyMid: '#15C3D6',
  blueSkyLight: '#12afcb',
  blueSkyLighter: '#17d6eb',
  lightBlue: '#17D6EB',

  marrom: '#8D734B',

  green: '#37C77F',
  greenLight: '#3EE08F',
  greenLightest: '#0df2b1',

  blue: '#3842ff',
  blueDark: '#100c2c',
  blueMid: '#001b48',

  grayMid: '#5c8599',
  grayLightest: '#f5f8fa',

  gradientLandingPage: 'linear-gradient(329.54deg, #29b6d1 0%, #00c7c7 100%)',
  gradientLandingPageDark:
    'linear-gradient(329.54deg, #001b48 0%, #100c2c 100%)',
};
